export default {
	props: {
		// Custom relation table
		table: {
			type: String,
			default: null
		},
		// Custom relation column
		columnSearch: {
			type: String,
			default: null
		},
		// Custom relation return value
		retKey: {
			type: String,
			default: '_EntityId'
		},
		// Custom relation return value
		retLabel: {
			type: String,
			default: null
		},
		// Custom relation filter
		filter: {
			type: Array,
			default: null
		},
		// Only show valid values
		strict: {
			type: Boolean,
			default: true
		},
		// Multiple
		multiple: {
			type: Boolean,
			default: null
		},
		limit: {
			type: Number,
			default: 5
		}
	},
	data() {
		return {
			dataSource: [],
			dataLoading: false,
			relationDefaultValue: { key: '', label: 'Selecciona una opción' }
		};
	},
	computed: {
		relationModelValue() {
			if (typeof this.value !== 'object' || this.value === null) {
				return this.parseDefaultValue();
			}

			return this.value;
		}
	},
	methods: {
		relationChange(value, emit = 'input') {
			if (value) {
				if (this.attrs.multiple) {
					const values = [];
					value.forEach((v) => {
						if (v.data) {
							values.push({ ...v });
						} else {
							let data = null;
							const index = this.dataSource.findIndex((item) => item.value === v.key);

							if (index > -1) {
								({ data } = this.dataSource[index]);
							} else {
								const index2 = this.value.findIndex((item) => item.key === v.key);
								if (index2 > -1) ({ data } = this.value[index2]);
							}

							values.push({ ...v, data });
						}
					});

					this.$emit(emit, this.parseValue(values));
				} else {
					const index = this.dataSource.findIndex((item) => item.value === value.key);

					let data = null;
					if (index > -1) ({ data } = this.dataSource[index]);

					this.$emit(emit, this.parseValue({ ...value, data }));
				}
			} else {
				this.$emit(emit, this.parseDefaultValue());
			}

			this.dataSource = [];
			this.dataLoading = false;
		},
		relationSimpleChange(value, type) {
			const parsedValue = this.parseValue(value);

			if (type === 'input') {
				this.$emit('input', parsedValue);
			} else if (type === 'select' && parsedValue.substr(0, 1) === '_') {
				const id = parsedValue.substr(1, parsedValue.length);
				const find = this.dataSource.find((x) => x.value === parsedValue);

				if (find) {
					this.$emit('input', { label: find.text, key: id, data: find.data });
				}
			}
		},
		async relationFetch(value, strict = true) {
			this.dataLoading = true;

			let filters = this.filter;

			if (value && this.attrs.columnSearch) {
				filters.push({
					_ParentOperator: 'OR',
					_Operator: 'OR',
					Fields: {
						[this.attrs.columnSearch]: {
							type: 4,
							string: this.value,
							opt: '='
						}
					}
				});
			} else if (value) {
				const globalSearchFilter = this.$gestios.$utils.filter(this.attrs.table, value);
				if (globalSearchFilter && filters) {
					filters.push(globalSearchFilter[0]);
				} else {
					filters = [globalSearchFilter[0]];
				}
			}

			const results = await this.$gestios.items(this.attrs.table).list({
				page: 1, filters, limit: this.limit, silent: true
			});

			this.dataLoading = false;

			if (strict) {
				this.dataSource = [];
				if (results.ok) {
					results.data.forEach((item) => {
						this.dataSource.push({
							text: item[this.attrs.retLabel].toString(),
							value: item[this.attrs.retKey].toString(),
							data: item
						});
					});
				}
			} else {
				this.dataSource = [];
				if (results.ok) {
					results.data.forEach((item) => {
						this.dataSource.push({
							text: item[this.attrs.retLabel].toString(),
							value: `_${item[this.attrs.retKey].toString()}`,
							data: item
						});
					});
				}
			}
		},
		relationParseValue(value) {
			let needToConvert = false;

			if (value) {
				let item;
				switch (typeof value) {
					case 'object':
						if (value._EntityId !== undefined) needToConvert = true;

						if (this.strict) {
							if (this.attrs.multiple) {
								const values = [];

								if (value.length > 0) {
									value.forEach((v) => {
										if ((v.key || v.key === 0) && v.label) {
											if (Number.isInteger(v.key)) v.key = v.key.toString();
											v.label = v.label.replace(/(\r\n|\n|\r|\t)/gm, '');
											values.push(v);
										} else if (v._EntityId !== undefined) {
											values.push({
												label: v[this.attrs.retLabel].toString(),
												key: v[this.attrs.retKey].toString(),
												data: v
											});
										}
									});
								}

								return values;
							}

							if (needToConvert) {
								return {
									label: value[this.attrs.retLabel].toString(),
									key: value[this.attrs.retKey].toString(),
									data: value
								};
							}

							if ((value.key || value.key === 0) && value.label) {
								if (Number.isInteger(value.key)) value.key = value.key.toString();
								value.label = value.label.replace(/(\r\n|\n|\r|\t)/gm, '');
								return value;
							}
						} else if (value[this.attrs.retLabel] !== undefined) {
							return value[this.attrs.retLabel].toString();
						}

						break;

					case 'string':
						if (this.strict) {
							item = this.fetchVault(value);
							if (item) {
								return {
									label: item[this.attrs.retLabel].toString(),
									key: item[this.attrs.retKey].toString(),
									data: item
								};
							}
						} else {
							return value;
						}
						break;

					case 'number':
						item = this.fetchVault(value);
						if (item) {
							return {
								label: item[this.attrs.retLabel].toString(),
								key: item[this.attrs.retKey].toString(),
								data: item
							};
						}
						break;

					default:
						return this.parseDefaultValue();
				}
			}

			return this.parseDefaultValue();
		},
		relationParseDefaultValue() {
			let defaultValue = '';

			if (this.attrs.multiple) {
				if (this.defaultValue !== null && typeof this.defaultValue === 'object') {
					({ defaultValue } = this);
				} else {
					defaultValue = [];
				}
			} else if (this.defaultValue !== null) {
				if (typeof this.defaultValue === 'object') {
					if (this.defaultValue.key !== undefined && this.defaultValue.label !== undefined) {
						defaultValue = {
							key: this.defaultValue.key,
							label: this.defaultValue.label,
							data: this.defaultValue
						};
					}
				}
			} else if (this.strict) defaultValue = this.relationDefaultValue;

			return defaultValue;
		}
	}
};
